
<script>
	import listBase from '@_system/components/base/list.vue'
	import adjustForm from './lib/adjust/index.vue'
	import footerIndex from './footer/index.vue'
	export default {
		extends: listBase,
		name: 'pricefluctuationsIndex',
		props: {

		},
		render(h) {
			this.$slots.mainheader = [
				<el-switch style="padding-right:20px" v-model={this.showAdjust} onChange={this.adjustChange} active-text="显示已调价" inactive-text=""></el-switch>,
				<el-tag type="danger" size="mini">调价后自动生成万里牛调价单,并将新价格同步到供应商</el-tag>
				
			]
			this.$slots.footer = [
				<div style="position: relative;width: 100%;height:100%;">
					<footer-index currentRow={this.currentrow} ref="wlnpurchaseFooter" />
				</div>
			]
			this.$slots.plug = [
				<adjust-form ref="adjustForm" row={this.currentrow} onSuccess={this.adjustSuccess} />
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				showAdjust:false,
				moduleName: 'pricefluctuations',
				windowName: '价格波动',
				windowType: 'modal',
				currentrow:null
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			beforeCreateGrid(formConfig, columns){
				columns.forEach((item)=>{
					if(item.field=='percent'){
						item.slots = {
							default: ({row}) => {	
								row.controll = ''
								let str= []
								if(row.message=='height'){
									str.push(<span style="color:#F56C6C;">{'+'+row.percent}</span>)
								}
								if(row.message=='low'){
									str.push(<span style="color:#67C23A;">{'-'+row.percent}</span>)
								}
								return str
							}
						}
					}
					// if(item.field == 'custommark'){
					// 	item.align = 'center'
					// 	item.editRender = {
					// 		name:'$input',
					// 		enabled:true,
					// 		props:{
					// 			placeholder:'自定义备注',
					// 		},
					// 		events:{
					// 			blur:({row})=>{
					// 				this.custommarkChange(row)
					// 			}
					// 		}
					// 	}
					// }
				})
			},
			custommarkChange(e){
				this.$api.pricefluctuations.updatefromlist(e.id,{custommark:e.custommark}).then((res)=>{
					if(res){
						this.$message.success('操作成功')
					}
					
				})
			},
			synchronous(data){
				let checkdata = data?data:this.$refs[this.moduleName + '_list'].getCheckboxRecords()
				if(checkdata.length==0){
					this.$message.error('请选择数据')
				}else{
					this.$api.supplier.updategoodsprice({data:checkdata}).then(()=>{
						this.$message.success('同步成功')
						this.customreload()
					})
					
				}
			},
			adjust(row){
				this.currentrow = row
				this.$refs.adjustForm.modalShow()
	
			},
			adjustSuccess(e){
				let data = JSON.parse(JSON.stringify(this.currentrow))
				data.newprice = e.newprice
				this.synchronous([data])
			},
			adjustChange(e){
				this.foreingKey.showadjust = e?1:0
				this.customreload()
			},
			cellClick(e) {
				if (e.column.field) {
					this.currentrow = e.row
				}
				
			},
			// cellStyle({
			// 	row,
			// 	column
			// }) {
			// 	if (column.property && column.property.indexOf('custommark') !== -1) {
			// 		return {
			// 			backgroundColor: 'rgb(225, 243, 216)'
			// 		}
			// 	}
			// },
		},
		components: {
			adjustForm,
			footerIndex
		}
	}
</script>
